import { Vue, Component, Prop, Watch } from "@wagich/vue-facing-decorator-metadata";
import { nanoid } from "nanoid";

import { render } from "./collapsible-card.html";

@Component({
	render,
})
export class CollapsibleCard extends Vue {
	@Prop({ required: false }) class: string | null;
	@Prop({ required: false, default: false }) open: boolean;
	@Prop({ required: false, default: false }) frameless: boolean;
	@Prop({ required: false, default: false }) fullbleed: boolean;

	id: string = `collapsible-${nanoid(8)}`;
	isOpen: boolean = false;

	mounted() {
		this.onOpenChanged(this.open);
		window.addEventListener("hashchange", this.openIfFragmentMatches);
		// The anchor lives in slotted content, which for a custom element is not queryable the instant it
		// mounts (getElementById still returns null); defer until the render flush has settled.
		this.$nextTick(() => this.openIfFragmentMatches());
	}

	beforeUnmount() {
		window.removeEventListener("hashchange", this.openIfFragmentMatches);
	}

	@Watch("open")
	onOpenChanged(newValue: boolean) {
		this.isOpen = newValue;
	}

	// Opens the card when the URL fragment points at an element inside its content — e.g. a hosted-document
	// redirect landing on "…/freunde#id-{friendId}". While the card is collapsed the anchor is display:none,
	// so the browser's own fragment navigation can neither reveal nor scroll to it; do both here.
	private openIfFragmentMatches() {
		let fragment = location.hash.slice(1);
		if (fragment === "") {
			return;
		}
		try {
			fragment = decodeURIComponent(fragment);
		} catch {
			// not valid percent-encoding — match against the raw fragment
		}

		const target = document.getElementById(fragment);
		if (target == null || !this.$el.contains?.(target)) {
			return;
		}

		this.isOpen = true;
		// The content slides open, so its final position is only settled once the animation finishes;
		// scroll it into view after that.
		window.setTimeout(() => target.scrollIntoView({ behavior: "smooth", block: "center" }), 400);
	}
}
